import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from '@material-ui/core';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { TimerIcon } from '../ManageTickets/icons/TimerIcon';
import { useStyles } from '../styles';

const RunStatePopup = ({ data, open, onClose, onSubmit }: any) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.popupTitle}>
        <DialogTitle>
          <span className={classes.runStatePopupTitle}>
            {data.title || 'Request received to run ticket'}
          </span>
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <div className={classes.runStatePopupContent}>
          <div className={classes.runStatePopupContentTitle}>
            <TimerIcon />
            <span>
              The output is being generated and may take some time to appear.
            </span>
          </div>
          <div className={classes.runStatePopupContentText}>
            Please note that output won't be available immediately, as the
            process involves some AI computation and loading time.
          </div>
        </div>
      </DialogContent>
      <DialogActions
        className={`${classes.justifyContentEnd} ${classes.customPadding}`}
      >
        <Button
          variant='contained'
          color='primary'
          onClick={onSubmit}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RunStatePopup;
